/*
 * Copyright (C) America Móvil S.A.B de C.V - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Juan Manuel Garcia Junco Moreno <manue.garcia@ironbit.com.mx>, April 2020
 */
import platform from 'platform';

const deviceInfo = platform.parse(window.navigator.userAgent);
const os = deviceInfo.os.toString();

Object.defineProperty(deviceInfo.os, 'description', {
  value: os === 'null' ? '' : os,
  enumerable: true,
  writable: false,
  configurable: false
});

export default deviceInfo;



// WEBPACK FOOTER //
// ./src/devices/all/deviceInfo.js